import * as React from 'react';

import { PlanType } from '@showbie-socrative/socrative-utils';
import { translate } from '~l10n/client';
import { atom, useAtom, useSetAtom } from 'jotai';

import { UIButton } from '~shared/components/buttons';
import { DialogConfirmation } from '~shared/components/Dialog';
import { selectedTeamIdAtom } from '~teacher/components/Account/atoms';
import { useTeamSubscriptionPlan } from '~teacher/components/Account/TeamMembers/TeamMembersTable';
import { ContactSalesLinkButton } from '~teacher/components/Account/TeamMembers/TeamMembersTable/AddSeatsDialog/Components/ContactSalesLinkButton';
import { ManageSeatsButton } from '~teacher/components/Account/TeamMembers/TeamMembersTable/AddSeatsDialog/Components/ManageSeatsButton';

import platform from '../../../../../../../../../shared/Platform';

export function ChangeToPaidAddSeatsDialog() {
  const [selectedTeamId] = useAtom(selectedTeamIdAtom);

  const teamSubscriptionPlan = useTeamSubscriptionPlan(selectedTeamId);

  const [isOpen, setIsOpen] = useAtom(isAddSeatsDialogOpenAtom);
  const [isLoading, setIsLoading] = React.useState(false);

  const onClose = () => {
    setIsOpen(false);
    setIsLoading(false);
  };

  return (
    <DialogConfirmation
      open={!platform.isWrapperApp() && isOpen}
      onClose={onClose}
      id="add-subscription-seats-dialog"
      title={translate('Add Seats to Your Subscription')}
      actions={[
        <UIButton key="cancel" isLoading={isLoading} onClick={onClose}>
          {translate('Cancel')}
        </UIButton>,
        ...(teamSubscriptionPlan.data === PlanType.Organization
          ? [
              <ContactSalesLinkButton
                onClick={() => {
                  setIsOpen(false);
                }}
                key="contact-sales"
              />,
            ]
          : [
              <ManageSeatsButton
                key="manage-seats"
                selectedTeamId={selectedTeamId}
                onSubmit={() => setIsOpen(false)}
                onSubmitClick={() => {
                  setIsLoading(true);
                }}
                isLoading={isLoading}
              >
                {translate('Manage Seats')}
              </ManageSeatsButton>,
            ]),
      ]}
    >
      {translate(
        'You must have available seats to upgrade a member. Manage your subscription to add seats.'
      )}
    </DialogConfirmation>
  );
}

const isAddSeatsDialogOpenAtom = atom<boolean>(false);

ChangeToPaidAddSeatsDialog.useOpenDialog = () => {
  const setIsOpen = useSetAtom(isAddSeatsDialogOpenAtom);
  return () => {
    setIsOpen(true);
  };
};
